module.exports = {"en_GB":"£/m3 ","de_DE":"€/m3 ","nl_NL":"€/m3 ","fr_FR":"€/m3 ","it_IT":"€/m3 ","es_ES":"€/m3 ","da_DK":"€/m3 ","sv_SE":"€/m3 ","no_NO":"€/m3 ","pl_PL":"€/m3 ","ru_RU":"€/m3 ","ar_SA":"€/m3 ","en_US":"$/CGL ","pt_PT":"€/m3 ","fi_FI":"€/m3 ","sk_SK":"€/m3 ","cs_CZ":"€/m3 "}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config/meas_units.json
// module id = no20
// module chunks = 0